<template>
  <FormInput ref="field" v-bind="_props" v-on="$listeners" v-mask="mask" />
</template>

<script>
import mask from 'vue-the-mask/src/directive'
import formFieldInterfaceMixin from '@/components/_shared/Form/form-field-interface-mixin'
import FormInput from '@/components/_shared/Form/Input/FormInput.vue'
import propsInput from '@/components/_shared/Form/Input/props-input'

const CPF_MASK = '###.###.###-##'

export default {
  name: 'CpfFormInput',
  components: { FormInput },
  directives: { mask },
  mixins: [formFieldInterfaceMixin],

  props: { ...propsInput },

  computed: {
    mask() {
      return [CPF_MASK]
    },
  },
}
</script>
